/**
 * Finished-day status for coach analytics (FD1) and optional Finish day confirm (FD2).
 *
 * Closed ≠ complete ≠ confirmed — see docs/mealmap/FINISHED_DAY_STORIES.md.
 */
/**
 * Normalize to local calendar yyyy-MM-dd.
 * Accepts `yyyy-MM-dd` strings or Date (uses local Y/M/D).
 */
export function toLocalDateString(date) {
    if (typeof date === 'string') {
        const m = /^(\d{4}-\d{2}-\d{2})/.exec(date.trim());
        if (m) {
            return m[1];
        }
        const parsed = new Date(date);
        if (!Number.isNaN(parsed.getTime())) {
            return formatYmdLocal(parsed);
        }
        return date.slice(0, 10);
    }
    return formatYmdLocal(date);
}
function formatYmdLocal(d) {
    const y = d.getFullYear();
    const m = String(d.getMonth() + 1).padStart(2, '0');
    const day = String(d.getDate()).padStart(2, '0');
    return `${y}-${m}-${day}`;
}
/**
 * A day is closed when local calendar has moved past it, or finishedAt is set
 * (explicit Finish day / implicit next-day confirm).
 */
export function getDayClosedStatus(args) {
    const dateStr = toLocalDateString(args.date);
    const todayStr = toLocalDateString(args.today ?? new Date());
    const hasFinishedAt = args.finishedAt != null &&
        String(args.finishedAt).trim() !== '' &&
        !Number.isNaN(new Date(args.finishedAt).getTime());
    if (hasFinishedAt || dateStr < todayStr) {
        return { closed: true, inProgress: false };
    }
    return { closed: false, inProgress: true };
}
